import { useState } from 'react'
import { getSelectedTicketsFromStorage, removeSelectedTicketsFromStorage, setSelectedTicketsToStorage } from 'utils/sessionStorage'

export const useSelectedSeats = (eventId: string) => {
    const initialTickets = getSelectedTicketsFromStorage(eventId)

    const [selectedSeats, setSelectedSeats] = useState<string[]>(initialTickets)

    const changeSelectedSeats = (updatedTickets: string[]) => {
        setSelectedTicketsToStorage(updatedTickets, eventId)
        setSelectedSeats(updatedTickets)
    }

    const clearSelectedSeats = () => {
        removeSelectedTicketsFromStorage(eventId)
        setSelectedSeats([])
    }

    return { selectedSeats, changeSelectedSeats, clearSelectedSeats }
}
